export enum VerticalSplitComponent {
  HERO = 'Hero',
  HEROSLIDER = 'HeroSlider',
}
